module.exports = __webpack_public_path__ + "img/bobav_bobocoin.gm.57140ca.png";